/* Built In Imports */
import { useContext, useEffect } from 'react';

/* External Imports */
import { Box } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import Breadcrum from '@components/Navigation/Breadcrum';
import HeadComponent from '@components/Utility/HeadComponent';
import config from '@config';
import WrapLayout from '@Layout/WrapLayout';
import { AuthContext } from '@store/auth-context';

/* Services */
import { getLocale } from '@components/Utility/Shared/SharedService';
import RenderSections from '@landing_pages/csr/Common/RenderSection';
import {
  fetchFooterData,
  fetchHeaderMenuData,
  fetchHeaderTopMenuData,
} from 'services/commonService';
import { fetchDetails, getLandingPaths } from 'services/othersService';

/* Styles */

/**
 * @param {string} region - Current User Region
 * @param {string} language - Current User Language
 * @param {string} pageData - Center Landing Page Data
 */


const CSRPage = ({ region, language, pageData }) => { 
  const formElement = pageData?.pageConfig?.partnerwithusform;
  const authContext = useContext(AuthContext);

  useEffect(() => {
    authContext.RegionAndLang(region, language);
  }, [authContext, region, language]);

  return (
    <WrapLayout>
      <HeadComponent
        data={pageData?._seoMetaTags || pageData?.seoFields}
        availableLocals={pageData?.availableLocales}
        pageconfig={pageData?.pageConfig}
      />
      <Box
        as="section"
        className="page-wrap container-article"
        p={{ base: '0px 0px 40px 0px', md: '0px 0px 80px 0px' }}
      >
        {
          pageData?.body?.map((section, index) => {
            return (
              <RenderSections
                section={section} 
                region={region}
                language={language} 
                formElement={formElement} />
            )
          }
          )
        }
      </Box>
      <style jsx global>
        {`
          .textlink a {
            color: #BB3E03;
            text-decoration: underline;
          }
        `}
      </style>
    </WrapLayout>
  );
};

export const getStaticPaths = async () => {
  const csrLandingPaths = config.USE_LOCAL_URL
    ? [
      `/in/en/corporate-social-responsibility`
    ]
    : await getLandingPaths('lvl0', '/corporate-social-responsibility');
  return {
    paths: csrLandingPaths,
    fallback: false,
  };
};

export const getStaticProps = async ({
  preview,
  previewData,
  params: { region, language, others },
  req,
}) => {
  const headerTopMenuData = await fetchHeaderTopMenuData(
    getLocale(region, language),
    'isotopmenu'
  );
  const headerMenuData = await fetchHeaderMenuData(
    getLocale(region, language),
    'isomainmenu'
  );
  const footerData = await fetchFooterData(
    getLocale(region, language),
    'isofooter'
  );
  const pageData = await fetchDetails(region, language,
    `corporate-social-responsibility`,
    { preview, data: previewData }
  );

  return {
    props: {
      headerTopMenuData: headerTopMenuData?.data || null,
      headerMenuData: headerMenuData?.data || null,
      region: region,
      language: language,
      footerData: footerData?.data || null,
      pageData: pageData || null,
      isPreview: preview ? true : false,
    },
  };
};

export default CSRPage;
